'use client';

import clsx from 'clsx';
import { useContext } from 'react';

import { Alter25Skeleton } from '@/components/alter25/Alter25Skeleton';
import { ShopContext } from '@/context/ShopContext';

export const SwabKitProductDetailsPricing: React.FC = () => {
  const { cartIsReadyForCheckout, cartTotalPrice, cartSaveAmount, regularPrice } =
    useContext(ShopContext);

  return (
    <div className="inline-flex lg:flex-col flex-wrap justify-start items-center lg:items-start mb-4 md:mb-8 gap-y-2 gap-x-4">
      <div className="flex justify-start items-center gap-3">
        <div className={clsx('font-light', 'responsive-text-24-32')}>
          {/* <span className="text-alter25-red me-2">-50%</span> */}
          <div className="text-alter-black min-w-[50px]">
            {(cartIsReadyForCheckout && cartTotalPrice()) || <Alter25Skeleton />}
          </div>
        </div>
        <div
          className={clsx(
            'bg-alter25-red text-white py-1 px-3 rounded-2xl',
            'responsive-text-14-16'
          )}
        >
          {cartIsReadyForCheckout && cartSaveAmount() ? (
            <>Save {cartSaveAmount()} </>
          ) : (
            <Alter25Skeleton className="min-w-[50px]" colorSet="red" />
          )}
          {/* <div>Save {cartSaveAmount() || <Alter25Skeleton className="inline" />}</div> */}
        </div>
      </div>

      <div
        className={clsx(
          'text-alter-black-80 font-light',
          'text-[15px] leading-[18px] tracking-[-0.48px]',
          'sm:text-base sm:leading-[19.2px] sm:tracking-[-0.45px]'
        )}
      >
        <span className="me-1">Regular Price:</span>
        <span className="line-through">${regularPrice}</span>
      </div>

      {/* <div
        className={clsx(
          'text-alter-black-80',
          'text-[15px] leading-[18px] tracking-[-0.48px]',
          'sm:text-base sm:leading-[19.2px] sm:tracking-[-0.45px]'
        )}
      >
        <span className="text-base me-1">1,100+ bought</span>
        <span className="text-base text-alter-black/80 font-light">In past month</span>
      </div> */}
    </div>
  );
};
